import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { SPOTIFY } from "@/lib/constants";
import { Reveal } from "./Reveal";
import { FloatingOrbs } from "./FloatingOrbs";

export const Music = () => {
  return (
  <section id="musica" className="px-5 sm:px-8 lg:px-12 py-24 sm:py-32" data-testid="music">
    <div className="relative mx-auto max-w-6xl overflow-hidden rounded-[2.5rem] border border-white/70 px-6 sm:px-14 py-14 sm:py-20"
      style={{ background: "linear-gradient(135deg, #FCEBFB 0%, #FBCFE8 38%, #D3EEFF 72%, #CFEFDD 100%)" }}>
      <FloatingOrbs />
      <div className="relative z-10 grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
        <Reveal>
          <motion.div className="mx-auto w-full max-w-sm animate-float">
            <div className="overflow-hidden rounded-[1.75rem] glass-strong p-2.5">
              <img
                src={SPOTIFY.cover}
                alt={`Copertina — ${SPOTIFY.title}`}
                className="aspect-square w-full rounded-[1.35rem] object-cover"
                data-testid="music-cover"
              />
            </div>
          </motion.div>
        </Reveal>

        <Reveal delay={0.1}>
          <p className="mb-4 text-xs uppercase tracking-[0.3em] text-ocean-deep">Il brano ufficiale</p>
          <h2 className="font-serif tracking-tightest text-4xl sm:text-6xl leading-[1.0] text-navy">
            {SPOTIFY.title}
          </h2>
          <p className="mt-5 max-w-md text-lg leading-relaxed text-navy-soft">
            C’è una frase che accompagna ogni concerto: stampata sui biglietti, sussurrata prima del primo accordo, gridata dal pubblico durante l’ultimo ritornello.
          </p>

          <a
            href={SPOTIFY.track}
            target="_blank"
            rel="noreferrer"
            data-testid="music-spotify-btn"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-navy px-7 py-3.5 text-base font-medium text-white transition-transform duration-300 hover:scale-[1.03]"
          >
            <Play size={16} className="fill-current" /> Ascolta su Spotify
          </a>
        </Reveal>
      </div>
    </div>
  </section>
  );
};
